import React from "react";
import {
  Building2,
  Calculator,
  Users,
  ShieldCheck,
  FileText,
  PhoneCall,
  ArrowUpRight,
} from "lucide-react";
import { services } from "../mock";

const iconMap = { Building2, Calculator, Users, ShieldCheck, FileText, PhoneCall };

const Services = () => {
  return (
    <section id="services" className="py-24 bg-brand-50/60">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-[12px] tracking-[0.3em] uppercase text-accent2 font-semibold">
              Leistungen
            </div>
            <h2 className="mt-3 font-display text-[36px] md:text-[46px] leading-tight font-extrabold text-brand-900">
              Unsere Dienstleistungen. Ihre Sicherheit.
            </h2>
          </div>
          <p className="text-brand-700 max-w-md leading-relaxed">
            Unsere Leistungen orientieren sich vollständig am Wohnungseigentumsgesetz und decken
            alle relevanten Bereiche einer modernen WEG-Verwaltung ab.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || Building2;
            return (
              <div
                key={s.id}
                className="group relative bg-white rounded-3xl p-8 border border-brand-100 hover:border-brand-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand-900/5 transition-all duration-300"
              >
                <div className="absolute top-6 right-6 text-brand-200 group-hover:text-accent2 transition-colors">
                  <ArrowUpRight className="w-5 h-5" />
                </div>
                <div className="w-14 h-14 rounded-2xl bg-brand-900 group-hover:bg-accent2 transition-colors flex items-center justify-center text-white">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="mt-6 text-[11px] tracking-widest uppercase text-brand-400">
                  0{i + 1}
                </div>
                <h3 className="mt-2 font-display font-bold text-xl text-brand-900">{s.title}</h3>
                <p className="mt-3 text-[14px] leading-relaxed text-brand-600">{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
